export const createSubscriptionApi = (apiCall: any) => ({
  getSubscriptionInfo: async () => await apiCall("/subscription/info", "GET"),
  createSubscription: async (plan?: string) =>
    await apiCall("/subscription/create", "POST", { plan: plan || "comply-starter" }),
  cancelSubscription: async () => await apiCall("/subscription/cancel", "POST"),
  redeemPromoCode: async (code: string) =>
    await apiCall("/subscription/redeem-code", "POST", { code }),
});
